import * as React from "react";
import { Toaster } from "@fluentui/react-components";

import ErrorMessageDialog from "../dialogs/ErrorMessagesDialog";
import Navigator from "./Navigator";
import Routes from "./routes/Routes";

import { ErrorContext } from "../store/error-context-api";
import { ToasterContext } from "../store/toaster-context-api";

export default function App() {
  const toasterId = React.useContext(ToasterContext);
  const { openErrorDialog, setOpenErrorDialog } = React.useContext(ErrorContext);

  return (
    <>
      <Navigator />
      <Routes />
      <Toaster timeout={1000} pauseOnHover toasterId={toasterId} position="bottom-end" />
      <ErrorMessageDialog open={openErrorDialog} setOpen={setOpenErrorDialog} />
    </>
  );
}
